<template>
  <section class="register-content">
    <Breadcrumb :links="links" />
    <form class="register-content-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12 col-lg-6 content-select-category">
          <div
            class="content-input-default-select"
            :class="{
              'content-input-default-select--active': hasSelectedSpecialty,
              'content-input-default-select--disabled': hasContentParams,
            }"
          >
            <select v-model="selectedSpecialty" required>
              <option value="" selected>Selecione a especialidade</option>
              <option
                v-for="specialty in specialties"
                :key="specialty.id"
                :value="specialty.id"
                :disabled="isContentRegistered(specialty.id)"
              >
                {{ specialty.name }}
                <span v-if="isContentRegistered(specialty.id)">
                  - Já registrado
                </span>
              </option>
            </select>
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_35_1490"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="7"
                height="12"
                style="mask-type: luminance"
              >
                <path
                  d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                  fill="white"
                ></path>
              </mask>
              <g mask="url(#mask0_35_1490)">
                <path
                  d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                  fill="black"
                ></path>
              </g>
            </svg>
          </div>
        </div>
        <div class="col-12">
          <h2>Conteúdo da página (Obrigatório):</h2>
          <quill-editor
            v-model="contentPage.contentHtml"
            ref="refQuillEditor"
            :options="quillOptions"
          ></quill-editor>
        </div>
        <div class="col-12">
          <div class="faqs">
            <h2>Dúvidas frequentes (Opcional):</h2>
            <button
              class="faqs__register"
              type="button"
              @click="showModalFaqs()"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </button>
            <div v-if="hasContentFaqs" class="faqs__content">
              <CardFaqs
                v-for="faq in contentFaqs.data"
                :faq="faq"
                :key="faq.id"
                @edit-faq="handleEditFaq"
              />
            </div>
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar Conteúdos</button>
        </div>
      </div>
    </form>
    <ModalFaqs
      :id-specialty="selectedSpecialty"
      :edit-faq="editFaq"
      @edit-faq="handleEditFaq"
    />
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Breadcrumb from "@/components/breadcrumb/Index";
import ModalFaqs from "@/views/Content/components/ModalFaqs";
import CardFaqs from "@/views/Content/components/CardFaqs";

export default {
  data() {
    return {
      links: [
        {
          name: "Conteúdos das páginas",
          routerName: "ContentPages",
        },
        {
          name: "Registrar Conteúdo Especialidade",
          routerName: "RegisterContentSpecialty",
        },
      ],
      contentPage: {
        id_user: "",
        id_specialties: "",
        contentHtml: null,
      },
      selectedSpecialty: "",
      quillOptions: {
        placeholder: "Descreva aqui o conteúdo textual da paǵina...",
        readonly: false,
      },
      contentPagesParams: this.$route.params,
      editFaq: null,
    };
  },
  components: {
    Breadcrumb,
    ModalFaqs,
    CardFaqs,
  },
  computed: {
    ...mapGetters("User", ["user"]),
    ...mapGetters({
      specialties: "Professional/specialties",
      contentPages: "ContentPages/contentPages",
      contentPageData: "ContentPages/contentPage",
      contentFaqs: "ContentPages/contentFaqs",
    }),
    hasContentFaqs() {
      return (
        this.contentFaqs?.data &&
        Array.isArray(this.contentFaqs.data) &&
        this.contentFaqs.data.length > 0
      );
    },
    hasSelectedSpecialty() {
      return this.selectedSpecialty && this.selectedSpecialty !== "";
    },
    hasContentParams() {
      return (
        this.contentPagesParams &&
        Object.keys(this.contentPagesParams).length > 0
      );
    },
  },
  methods: {
    ...mapActions("Professional", ["consultSpecialties"]),
    ...mapActions("ContentPages", [
      "setDataDefault",
      "registerContentPages",
      "consultContentPages",
      "consultContentFaqs",
    ]),
    async handleSubmit() {
      if (!this.contentPage.contentHtml) {
        this.$swal.fire({
          icon: "warning",
          html: "Obrigatório o preenchimento do conteúdo da página!",
        });

        return;
      }

      const message = this.contentPage?.id
        ? "Conteúdo da página editado com sucesso!"
        : "Conteúdo da página cadastrado com sucesso!";

      this.contentPage.id_user = this.user.id;
      this.contentPage.id_specialties = this.selectedSpecialty;

      if (this.contentPage?.id) {
        delete this.contentPage.name;
      }

      await this.registerContentPages(this.contentPage);
      this.$router.push({ name: "ListContentSpecialties" });
      this.$swal.fire({
        icon: "success",
        html: message,
      });
    },
    isContentRegistered(id) {
      if (!this.contentPages?.data || this.contentPages.data.length === 0) {
        return false;
      }

      return this.contentPages?.data.some((item) => item.id_specialties === id);
    },
    showModalFaqs() {
      this.$bvModal.show("modal-faqs");
    },
    handleEditFaq(value) {
      this.editFaq = value;
    },
    clearContentFaqsVuex() {
      this.setDataDefault(["SET_CONTENT_FAQS", []]);
    },
  },
  async mounted() {
    this.clearContentFaqsVuex();
    this.consultSpecialties();

    if (this.hasContentParams) {
      await this.consultContentPages(this.contentPagesParams);
      await this.consultContentFaqs(this.contentPageData.id_specialties);

      this.contentPage = this.contentPageData;
      this.links[1].name = this.contentPage.name;
      this.selectedSpecialty = this.contentPage.id_specialties;
      return;
    }
  },
};
</script>

<style lang="scss" scoped>
.register-content {
  padding-bottom: 50px;
  &-form {
    h2 {
      font-size: 24px;
      font-family: "Font Semibold";
      color: var(--black);
      text-align: left;
      margin-bottom: 30px;
    }
  }
  .faqs {
    padding: 30px 0;
    border-top: 1px solid var(--gray-light);
    margin-top: 50px;
    &__register {
      width: 80px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: 0;
      border: 1px solid transparent;
      box-shadow: 0px 1px 3px rgb(0, 0, 0, 0.25);
      border-radius: 10px;
      margin-bottom: 30px;
      transition: 500ms;
      &:hover {
        cursor: pointer;
        border-color: var(--yellow);
      }
      img {
        max-width: 40px;
      }
    }
    &__content {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 20px;
      @media (max-width: 991px) {
        grid-template-columns: repeat(1, minmax(0, 1fr));
      }
    }
  }
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 30px;
}
.content-select-category {
  margin-bottom: 30px;
  .content-input-default-select {
    margin-bottom: 0;
  }
}
</style>
